<template>
    <div class="app" v-if="loaded">
        <div class="mobile-menu">
        <a href="/" v-if="!curSection"><img :src="logo" alt="Logo" class="logo"></a>
          <MenuIcon @click.native="menu = !menu" :open="menu"/>
          <Menu :style="{visibility: menu ? 'visible' : 'hidden'}" :show="menu"/>
        </div>
        <HomeSlide @click="curSection = $event"/>
        <!-- <Slide v-if="section" :section="section" @close="curSection = 0"/> -->
        <Slide :sectionNum="sectionNum" @close="curSection = 0"/>

    </div>
    <Loading @load="loaded = true" v-else/>
</template>

<script>
import HomeSlide from "./HomeSlide";
import Slide from "./Slide";
import MenuIcon from "./MenuIcon";
import Menu from "./Menu";
import Loading from "./Loading";

import { logo } from "../config";
// import sections from '../json/slides'

export default {
  name: "Home",
  components: {
    Loading,
    Menu,
    MenuIcon,
    Slide,
    HomeSlide,
  },
  data() {
    return {
      logo,
      curSection: 0,
      menu: false,
      loaded: false
    };
  },
  computed: {
    section() {
      return this.sections.find(item => item.id === this.curSection);
    },
    sectionNum() {
        return this.curSection
    }
  }
};
</script>

<style scoped lang="scss">
.app {
  width: 100%;
  height: 100%;

  .logo {
    position: fixed;
    z-index: 100;
    width: 150px;
    left: 60px;
    top: 50px;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
    .mobile-menu {
        height: 40px;
        background-color:#8EB8C9;
        position: fixed;
        z-index: 100;
        left: 0;
        top:0;
        width: 100%;
        .logo {
          width: 80px;
          left: 30px;
          top: 12px;
        }
    }
}

</style>
